module.exports = __webpack_public_path__ + "static/media/2122-service-2-7-min.a38ec63b.jpg";